// exports
export default {
  Username: /^[a-zA-Z0-9_]*$/,
  Email: /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/,
  Title: "^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z ]*)*$"
} as const;
